import React from 'react';
import { motion } from 'framer-motion';
import { ReceiptTextIcon, ScanLineIcon } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
const expenseTags = [{
  emoji: '🍽️',
  label: 'Dinner'
}, {
  emoji: '🚕',
  label: 'Taxi'
}, {
  emoji: '🍺',
  label: 'Drinks'
}, {
  emoji: '🎟️',
  label: 'Tickets'
}, {
  emoji: '🏠',
  label: 'Accommodation'
}, {
  emoji: '⛽',
  label: 'Fuel'
}, {
  emoji: '🛒',
  label: 'Big shop'
}, {
  emoji: '🎿',
  label: 'Lift pass'
}];
export function AddExpenses() {
  return <section id="features" className="bg-white py-20 lg:py-28" data-id="element-21" data-mp="19i68wd39cphr">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-22" data-mp="1nes4fhfni290">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-23" data-mp="1igqk6t6hnwvy">
          {/* Screen on the left this time */}
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative mx-auto w-full max-w-[330px] lg:max-w-[350px]" data-id="element-24" data-mp="3p6ogqt9n7g4u">
            <div aria-hidden="true" className="absolute -inset-5 rotate-2 rounded-[3rem] bg-[#FFFBF2]" data-id="element-25" data-mp="97qd3renljl1" />
            <PhoneFrame screen={screens.kittyMain} shadow="xl" className="relative -rotate-2" data-id="element-26" data-mp="ix1jv7e2ic5r" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} data-id="element-27" data-mp="n0prfq2p97r0">
            <h2 className="mb-5 text-3xl font-black leading-[1.1] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-28" data-mp="11vvwoatz12ja">
              Spent it? Pot it.
            </h2>
            <p className="mb-8 max-w-md text-lg leading-relaxed text-gray-600" data-id="element-29" data-mp="2yq0kz3qfveg7">
              Add an expense, choose who paid and split it between the people
              involved.
            </p>

            <ul className="mb-10 flex flex-wrap gap-2.5" data-id="element-30" data-mp="2vmt7sf0kurpo">
              {expenseTags.map(tag => <li key={tag.label} className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-[#FFFBF2] px-4 py-2 text-sm font-bold text-kitty-dark" data-id="element-31" data-mp="2qpkrkjyzoxr2">
                  <span aria-hidden="true" data-id="element-32" data-mp="3el5l8cyiunr2">{tag.emoji}</span>
                  {tag.label}
                </li>)}
            </ul>

            {/* Receipts — supporting, not headline */}
            <div className="rounded-3xl border border-gray-100 bg-[#FFFBF2] p-7 shadow-soft" data-id="element-33" data-mp="3oaywtdynz2vb">
              <div className="mb-4 flex gap-2" data-id="element-34" data-mp="3jc5ffag9arpv">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-kitty-yellow" data-id="element-35" data-mp="3jdgjlbdm61hi">
                  <ReceiptTextIcon className="h-5 w-5 text-kitty-dark" aria-hidden="true" data-id="element-36" data-mp="1726tfr2zxkp" />
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-kitty-yellow-100" data-id="element-37" data-mp="fszm12x6rzg4">
                  <ScanLineIcon className="h-5 w-5 text-kitty-yellow-700" aria-hidden="true" data-id="element-38" data-mp="kr9eh5rj0ly1" />
                </span>
              </div>
              <h3 className="mb-2 text-xl font-extrabold text-kitty-dark" data-id="element-39" data-mp="bql36itiozou">
                Keep the receipt. Lose the argument.
              </h3>
              <p className="text-base leading-relaxed text-gray-600" data-id="element-40" data-mp="3t6b1cfbtm9rg">
                Snap a photo of the bill and attach it to the expense. Scanning
                can fill in the details for you, worth a quick check before you
                save.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}